import { Notification, NotificationInterface } from "../../../Models/Notification";
import { BaseAPICallsHandler } from "../BaseAPICallsHandler";
import { NetworkUtils } from "../NetworkUtils";
import { ServerConfig } from "../ServerConfig";

export class NotificationAPIHandler {

  public static shared = new NotificationAPIHandler()

  apiHandler = BaseAPICallsHandler.shared
  serverConfig = ServerConfig.shared
  networkUtils = NetworkUtils.shared

  // dependency injection here
  constructor();
  constructor(apiHandler: BaseAPICallsHandler, serverConfig: ServerConfig, networkUtils: NetworkUtils);
  public constructor(...params: any[]) {
    if (params.length >= 3) {
      this.apiHandler = params[0];
      this.serverConfig = params[1];
      this.networkUtils = params[2];
    }
  };

  public async createNotification(userId: string, notificationData: any): Promise<Notification> {
    const url = this.serverConfig.NotificationAPIs.createNotificationAPI(userId);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makePostRequest(authHeaders, url, notificationData);
      const notificationData_ = response.data.notification;
      const notification = new Notification(notificationData_);
      return Promise.resolve(notification);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async getNotificationsForUser(): Promise<{allNotifications: Notification[], totalCount: number, pageNumber: number, pageSize: number}> {
    const url = this.serverConfig.NotificationAPIs.getNotificationsForUserAPI;
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makeGetRequest(authHeaders, url);
      const { notifications, totalCount, pageNumber, pageSize } = response.data;
      const allNotifications = notifications.map((item: any) => new Notification(item))
      return Promise.resolve({allNotifications, totalCount, pageNumber, pageSize});
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async markNotificationAsRead(notificationId: string): Promise<Notification> {
    const url = this.serverConfig.NotificationAPIs.markNotificationAsReadAPI(notificationId);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makePatchRequest(authHeaders, url, {});
      const updatedNotification = response.data.notification;
      const notification = new Notification(updatedNotification);
      return Promise.resolve(notification);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async markAllNotificationsAsRead(): Promise<any> {
    const url = this.serverConfig.NotificationAPIs.markAllNotificationsAsReadAPI;
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makePatchRequest(authHeaders, url, {});
      return Promise.resolve(response.data);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async deleteNotification(notificationId: string): Promise<any> {
    const url = this.serverConfig.NotificationAPIs.deleteNotificationAPI(notificationId);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makeDeleteRequest(authHeaders, url, {});
      return Promise.resolve(response.data);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async getNavbarNotifications(): Promise<{ unreadNotifications: NotificationInterface[], totalUnreadCount: number }> {
    const url = this.serverConfig.NotificationAPIs.getNavbarNotificationsAPI;
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makeGetRequest(authHeaders, url);
      const { unreadNotifications, totalUnreadCount } = response.data;
      const notifications = unreadNotifications.map((item: any) => new Notification(item));
      return Promise.resolve({ unreadNotifications: notifications, totalUnreadCount });
    } catch (err) {
      return Promise.reject(err);
    }
  }
}